<template>
    <div class="container home">
        <div class="jumbotron">
            <h1 class="display-4">{{ $t('productname') }}</h1>
            <p class="lead">{{ $t('home.appdescription') }}</p>
            <hr class="my-4">
            <p>{{ $t('home.appdescriptionextended') }}</p>
            <router-link v-if="!user.loggedIn" class="btn btn-primary btn-lg" to="/login">Login</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    computed: {
        user() {
            return this.$store.state.user;
        }
    }
};
</script>

<style lang="scss">
    .home {
        .jumbotron {
            opacity: 0.92;
        }
    }
</style>